import { v4 as uuidv4, validate } from 'uuid';

import { LoggerScope } from '~/main/utils/logger';
import { ANALYTICS_EVENTS } from '~/renderer/store/middleware/types';
import { isBrowserCFD, isClientSideReady, isRenderProcess } from '~/renderer/utils';
import FirebaseAnalyticsJS from '~/renderer/utils/analytics/FirebaseAnalyticsJS';
import Logger from '~/renderer/utils/logger';

const initializeAnalytics = () => {
  let analytics: FirebaseAnalyticsJS | undefined;

  if (isClientSideReady() && process.env.GOOGLE_ANALYTICS_KEY) {
    try {
      let clientId = localStorage.getItem('UUID') || '';
      if (!validate(clientId)) {
        clientId = uuidv4();
        localStorage.setItem('UUID', clientId);
      }

      analytics = new FirebaseAnalyticsJS(
        {
          measurementId: process.env.GOOGLE_ANALYTICS_KEY,
        },
        { clientId },
      );
    } catch (err) {
      Logger({ scope: LoggerScope.ANALYTICS }).error({
        msg: `Failed to initialize Analytics`,
        err,
      });
    }
  }

  return analytics;
};

export const track = async <T extends string>(
  event: ANALYTICS_EVENTS,
  data?: { [key in T]: number | string | boolean },
) => {
  if (analytics) {
    try {
      const aggregatedData = {
        ...data,
        version:
          isBrowserCFD && process.env.CFD_VERSION
            ? process.env.CFD_VERSION
            : process.env.HUB_VERSION,
        isDesktop: isRenderProcess,
      };

      await analytics.logEvent(event, aggregatedData);
    } catch (err) {
      Logger({ scope: LoggerScope.ANALYTICS }).error({
        msg: `Failed to send logEvent: ${event}`,
        err,
      });
    }

    Logger({ scope: LoggerScope.ANALYTICS }).debug({
      msg: event,
      ...data,
    });
  }
};

const analytics = initializeAnalytics();

export default analytics;
